import { render, staticRenderFns } from "./InsCmsCat7.vue?vue&type=template&id=504f6909&scoped=true&"
import script from "./InsCmsCat7.vue?vue&type=script&lang=ts&"
export * from "./InsCmsCat7.vue?vue&type=script&lang=ts&"
import style0 from "./InsCmsCat7.vue?vue&type=style&index=0&id=504f6909&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504f6909",
  null
  
)

export default component.exports